var chunkToChildrenMap = {
	"1392": [
		6394,
		3089,
		625
	],
	"2583": [
		1713,
		5122,
		6630
	],
	"7140": [
		6465
	],
	"7557": [
		6394,
		3089,
		625
	],
	"9307": [
		6630
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));